import robot from './modules/robot'
import cep from './modules/cep'
import workbench from '@/menu/modules/workbench'
import insight from './modules/insight'
// 用户管理
import user from './modules/user'
// 融媒管家
import rmplus from './modules/rmplus'
// 小程序
import mp from './modules/mp'
// 私有云盘
import cloud from './modules/cloud'
// 新闻宣传
import interview from './modules/interview'
// 申请审批
import apply from './modules/apply'
import topic from './modules/topic'
import submit from './modules/submit'
import spread from './modules/spread'
import tyc from './modules/tyc'
import yq from './modules/yq'
import group from './modules/group'
import mobile from './modules/mobile'

// 媒资库
import mediadata from './modules/mediadata'

// 系统设置
import system from './modules/system'

// 河南思政舆情
import hnyq from './modules/hnyq'

// 菜单 顶栏
export default [
  workbench,
  insight,
  tyc,
  topic,
  cep,
  mediadata,
  // cloud,
  spread,
  yq,
  // group,
  rmplus,
  user,
  mobile,
  apply,
  // interview,
  // mediadata
  system,
  hnyq
]
